import { ActionReducer, Action } from '@ngrx/store';
import { environment } from '../../environments/environment';

export const LANGUAGE = 'LANGUAGE';
export const DECREMENT = 'DECREMENT';
export const RESET = 'RESET';

export const languageReducer: ActionReducer<number> = (state:any, action:any) => {
    switch (action.type) {
        case LANGUAGE:
            if (!localStorage.getItem('language')) {
                return state = environment.langinit;
            } else {
                return action.payload;
            }
        default:
            if (!localStorage.getItem('language')) {
                return state = environment.langinit;
            } else {
                return localStorage.getItem('language');
            }
    }
};